import React, { Component } from "react";
import ClassNames from "classnames";

class Nav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileNavOpen: false,
            items: [
                {
                    "title": "profile",
                    "link": "#profile",
                    "isactive": true
                },
                {
                    "title": "work experience",
                    "link": "#work"
                },
                {
                    "title": "education",
                    "link": "#education"
                },
                {
                    "title": "achievements",
                    "link": "#achievements"
                }
            ]
        };
        this.toggleMobileNav = this.toggleMobileNav.bind(this);
        this.closeMobileNav = this.closeMobileNav.bind(this);
    }

    toggleMobileNav() {
        if (this.state.mobileNavOpen) {
            this.setState({
                mobileNavOpen: false
            });
        } else {
            this.setState({
                mobileNavOpen: true
            });
        }
    }

    closeMobileNav() {
        this.setState({
            mobileNavOpen: false
        });
    }

    render() {
        const navClasses = ClassNames({
          nav: true,
          "nav-open": this.state.mobileNavOpen
        });
        return (
            <header>
                <button className="nav-toggle" onClick={this.toggleMobileNav}>
                    <span>Menu</span>
                </button>
                <div className={navClasses}>
                    <ul className="nav-list">
                        <li className="nav-item name">
                            <span>Pat Kira</span>
                        </li>
                        {this.state.items.map((item, index) =>
                            <li className="nav-item" key={index}>
                                <a onClick={this.closeMobileNav} href={item.link}>{item.title}</a>
                            </li>
                        )}
                    </ul>
                </div>
            </header>
        )
    }
}

export default Nav;


// WEBPACK FOOTER //
// ./src/components/nav.js